import React from 'react';
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XMarkIcon
} from '@heroicons/react/24/solid';

const Alert = ({
  children,
  title,
  variant = 'info',
  isDismissible = false,
  onDismiss,
  className = '',
}) => {
  // Base classes
  const baseClasses = 'rounded-md p-4';
  
  // Variant classes and icons
  const variants = {
    info: {
      classes: 'bg-blue-50 border border-blue-200',
      titleClasses: 'text-blue-800',
      textClasses: 'text-blue-700',
      icon: InformationCircleIcon,
      iconClasses: 'text-blue-400',
    },
    success: {
      classes: 'bg-green-50 border border-green-200',
      titleClasses: 'text-green-800',
      textClasses: 'text-green-700',
      icon: CheckCircleIcon,
      iconClasses: 'text-green-400',
    },
    warning: {
      classes: 'bg-yellow-50 border border-yellow-200',
      titleClasses: 'text-yellow-800',
      textClasses: 'text-yellow-700',
      icon: ExclamationTriangleIcon,
      iconClasses: 'text-yellow-400',
    },
    error: {
      classes: 'bg-red-50 border border-red-200',
      titleClasses: 'text-red-800',
      textClasses: 'text-red-700',
      icon: ExclamationCircleIcon,
      iconClasses: 'text-red-400',
    },
  };
  
  const { classes, titleClasses, textClasses, icon: Icon, iconClasses } = variants[variant];
  
  return (
    <div className={`${baseClasses} ${classes} ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 ${iconClasses}`} aria-hidden="true" />
        </div>
        <div className="ml-3 flex-1">
          {title && (
            <h3 className={`text-sm font-medium ${titleClasses}`}>{title}</h3>
          )}
          <div className={`text-sm ${title ? 'mt-2' : ''} ${textClasses}`}>
            {children}
          </div>
        </div>
        {isDismissible && onDismiss && (
          <div className="ml-auto pl-3">
            <div className="-mx-1.5 -my-1.5">
              <button
                type="button"
                onClick={onDismiss}
                className={`inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                  variant === 'info' ? 'bg-blue-50 text-blue-500 hover:bg-blue-100 focus:ring-blue-600' :
                  variant === 'success' ? 'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-green-600' :
                  variant === 'warning' ? 'bg-yellow-50 text-yellow-500 hover:bg-yellow-100 focus:ring-yellow-600' :
                  'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-red-600'
                }`}
              >
                <span className="sr-only">Dismiss</span>
                <XMarkIcon className="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Alert;
